import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import _ from 'lodash';
import { QuotesGrid, ServiceThreadSpinner } from '.';
import { api, constants, helpers } from '../utils';

export default function CustomerQuotes(props) {
   const [customerId, setCustomerId] = useState(props.customerId);
   const [data, setData] = useState();
   const [loaded, setLoaded] = useState(false);

   useEffect(() => {
      if (props.customerId !== customerId) {
         setCustomerId(props.customerId);
         setLoaded(false);
      }

      if (!loaded) {
         loadData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.customerId]);

   function exportXlsx() {
      if (_.isNil(customerId) || customerId.length < 1) {
         return;
      }

      api
         .postGetBlob(`Customer/ExportCustomerQuotes/${customerId}`, null)
         .then(r => {
            if (r.data.success === false) {
               if (_.isString(r.data.message)) {
                  toast.error(r.data.message);
               }
               return;
            }
            if (r.data) {
               const XLSX_FILENAME = `${customerId}_Quotes.xlsx`
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler);
   }

   function loadData() {
      api
         .post(`Customer/GetCustomerQuotes/${customerId}`)
         .then(response => {
            if (response.data.success) {
               setData(response.data.quotes);
            }
            setLoaded(true);
         })
         .catch(api.catchHandler)
   }

   return (
      <>
         <div>
            <span className="h2 me-2">Current Quotes</span> <span className="text-muted">Customer #{customerId}</span>
         </div>
         <hr />
         <ServiceThreadSpinner on={!loaded}>
            {data && data.length
               ? (<QuotesGrid
                  data={data}
                  exportXlsxCallback={exportXlsx}
                  fromSales={false}
               />)
               : (<span className="h5">No Quotes found</span>)
            }
         </ServiceThreadSpinner>
      </>
   )
}
